import {
  FETCH_MEETINGS,
  SESSION_MEETINGS,
  MEETING_MODAL,
  MEETING_SETTING_OPEN,
  MEETING_SETTINGS,
  MEETING_SCHEDULE_DATES
} from '../actions';

// meeting details reducer 👇🏻
export const userMeetings = (state = [], action) => {
  if (action.type == FETCH_MEETINGS) return action.payload;
  return state;
};

export const sessionMeetings = (state = [], action) => {
  if (action.type === SESSION_MEETINGS) return action.payload;
  return state;
};

export const meetingModalReducer = (state = {}, action) => {
  if (action.type === MEETING_MODAL) return action.payload;
  return state;
};

// Meeting setting reducer start here 👇🏻
export const meetingSettingOpenReducer = (state = {}, action) => {
  if (action.type == MEETING_SETTING_OPEN) return action.payload;
  return state;
};

export const meetingSettingReducer = (state = {}, action) => {
  if (action.type == MEETING_SETTINGS) return action.payload;
  return state;
};

export const meetingScheduleDatesReducer = (state = [], action) => {
  if (action.type === MEETING_SCHEDULE_DATES) return action.payload;
  return state;
};
